










import AudioPromise from '@ivy/fts/audioPromise'
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
@Component
export default class MusicButton extends Vue {
  @Prop({ default: false }) activeOver: boolean
  @Prop() audioFile: any
  musicPlay: boolean = false
  handPlay: boolean = false
  bgMusic: any = null
  async mounted() {
    console.log('shirye', +this.audioFile, this.activeOver)
    this.bgMusic = new AudioPromise(
      this.audioFile,
      e => this.updateTime(e),
      e => this.updateStatus(e)
    )
    if (!this.activeOver) {
      this.bgMusic.play(0)
      this.musicPlay = true
    }
  }
  playBgMusic() {
    this.musicPlay ? this.bgMusic.pause() : this.bgMusic.play()
    this.musicPlay = !this.musicPlay
    this.handPlay = true
  }
  updateStatus(e) {
    if (e !== 'ended' && !this.handPlay) {
      this.bgMusic.play(0)
    }
  }
  updateTime(e) {
    if (e.target.currentTime >= e.target.duration) {
      this.handPlay = false
    }
  }
}
